export const STAKING_V2_ADDRESS: `0x${string}` =
  "0x82760c8D77D5513aA65cA43A3fF4d7e596726e7D";
